/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, bool } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import { idTransactionFormat } from "util/format";
import { getAccountDescription } from "util/accounts";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

class CancelTransactionDataTable extends Component {
    static propTypes = {
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
    };

    dataRow = () => {
        const { multipleSignaturesData, isDesktop } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;
        return selectedTransactionRows.map((object) => {
            const {
                idTransaction,
                data: { idTransactionToCancel, debitAccount, creditAccount, cbu },
            } = object.transaction;

            const externalCreditAccountValue = cbu !== undefined && cbu.slice(-14, -1);

            return (
                <CardContainer className="confirmation__cards-container">
                    <Card
                        className="confirmation__cards"
                        icon={isDesktop && "images/transfer-PENDING.svg"}
                        iconClass="card__pending-transaction-icon"
                        hrClass={!object.transaction?.data?.amount && "d-none"}
                        title={
                            !isDesktop &&
                            debitAccount?.number !== undefined &&
                            getAccountDescription(debitAccount) && (
                                <div className="confirmation-cards__title">
                                    <div className="confirmation-cards__title-data">
                                        <I18n id="transfers.debitAccount.label" />
                                    </div>
                                    <div className="confirmation-cards__title-info">
                                        <span>
                                            {debitAccount?.number !== undefined && getAccountDescription(debitAccount)}
                                        </span>
                                    </div>
                                </div>
                            )
                        }
                        content={
                            isDesktop ? (
                                <div className="d-flex align-items-center">
                                    {debitAccount?.number !== undefined && getAccountDescription(debitAccount) && (
                                        <div
                                            className={
                                                creditAccount?.number !== undefined &&
                                                getAccountDescription(creditAccount)
                                                    ? "confirmation-cards__content pb-1"
                                                    : "confirmation-cards__content"
                                            }>
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="transfers.debitAccount.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>
                                                    {debitAccount?.number !== undefined &&
                                                        getAccountDescription(debitAccount)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {creditAccount?.number !== undefined && getAccountDescription(creditAccount) && (
                                        <div className="confirmation-cards__content info-type-a">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="transfers.creditAccount.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>
                                                    {creditAccount?.number !== undefined &&
                                                        getAccountDescription(creditAccount)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {externalCreditAccountValue && (
                                        <div className="confirmation-cards__content info-type-a">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="transfers.creditAccount.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>{externalCreditAccountValue && externalCreditAccountValue}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    {creditAccount?.number !== undefined && getAccountDescription(creditAccount) && (
                                        <div className="confirmation-cards__content">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="transfers.creditAccount.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>
                                                    {creditAccount?.number !== undefined &&
                                                        getAccountDescription(creditAccount)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {externalCreditAccountValue && (
                                        <div className="confirmation-cards__content">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="transfers.creditAccount.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>{externalCreditAccountValue && externalCreditAccountValue}</span>
                                            </div>
                                        </div>
                                    )}
                                    {idTransactionFormat(idTransaction) && (
                                        <div className="confirmation-cards__content">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="forms.transaction.ticket.number" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>{idTransactionFormat(idTransaction)}</span>
                                            </div>
                                        </div>
                                    )}
                                    {idTransactionFormat(idTransactionToCancel) && (
                                        <div className="confirmation-cards__content">
                                            <div className="confirmation-cards__content-data">
                                                <I18n id="scheduled.transactions.cancel.idTransactionToCancel.label" />
                                            </div>
                                            <div className="confirmation-cards__content-info">
                                                <span>{idTransactionFormat(idTransactionToCancel)}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        bottom={
                            isDesktop && (
                                <div className="d-flex align-items-center">
                                    {idTransactionFormat(idTransaction) && (
                                        <div
                                            className={
                                                idTransactionFormat(idTransactionToCancel)
                                                    ? "confirmation-cards__bottom confirmation-cards-separator"
                                                    : "confirmation-cards__bottom"
                                            }>
                                            <div className="confirmation-cards__bottom-data">
                                                <I18n id="forms.transaction.ticket.number" />
                                            </div>
                                            <div className="confirmation-cards__bottom-info">
                                                <span>{idTransactionFormat(idTransaction)}</span>
                                            </div>
                                        </div>
                                    )}
                                    {idTransactionFormat(idTransactionToCancel) && (
                                        <div className="confirmation-cards__bottom">
                                            <div className="confirmation-cards__bottom-data">
                                                <I18n id="scheduled.transactions.cancel.idTransactionToCancel.label" />
                                            </div>
                                            <div className="confirmation-cards__bottom-info">
                                                <span>{idTransactionFormat(idTransactionToCancel)}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        rightContent={
                            object.transaction?.data?.amount?.currency &&
                            object.transaction?.data?.amount?.quantity && (
                                <div className="confirmation-cards__right">
                                    <div className="confirmation-cards__right-data">
                                        <I18n id="transfers.amount.label" />
                                    </div>
                                    <div className="confirmation-cards__right-info">
                                        <FormattedAmount
                                            currency={object.transaction?.data?.amount?.currency.toString()}
                                            quantity={object.transaction?.data?.amount?.quantity}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    />
                </CardContainer>
            );
        });
    };

    render() {
        return this.dataRow();
    }
}
const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(CancelTransactionDataTable));
